import { Environment } from './core/interfaces/environments.interface'

export const environment: Environment = {
	production: false,
	environmentsConfigsUrl: 'https://rbt.investlink.io/mobile/trading-dev.json',
}
